import { RouteRecordRaw } from 'vue-router'
import { constantRoutes, defaultRoutes } from '../constantRoutes'
import { moduleRoutes, menuSyncRoute, mobileMenuSyncRoute } from '../staticModules'

/**
 * 静态路由：全部子模块路由来自 views 下的 routes.ts，不使用后台权限路由
 */
const layoutRoute = constantRoutes.find((r) => r.path === '/') as RouteRecordRaw

const layoutChildren: RouteRecordRaw[] = [
  ...(layoutRoute.children || []),
  ...moduleRoutes,
  menuSyncRoute,
  mobileMenuSyncRoute
]

const staticRouter: RouteRecordRaw[] = [
  {
    ...layoutRoute,
    children: layoutChildren
  },
  ...constantRoutes.filter((r) => r.path !== '/'),
  ...defaultRoutes
]

export default staticRouter
